{% block sw_cms_block_jga_revocation_button %}
<div class="sw-cms-block-jga-revocation-button">
    <slot name="content">
        {% block sw_cms_block_jga_revocation_button_slot_content %}{% endblock %}
    </slot>
</div>
{% endblock %}
